import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
export default class CreateOrderCheckoutUseCase extends UseCase {
  constructor({repository, getCurrentUserService, createOrderCheckoutError}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._createOrderCheckoutError = createOrderCheckoutError
  }

  _throwCreateOrderCheckoutError(message) {
    throw this._createOrderCheckoutError(`[CreateOrderCheckoutErrorsRepository#get] ${message}`)
  }

  _getCurrentUser = async () => this._getCurrentUserService.execute()

  _getUserId = async () => {
    const currentUser = await this._getCurrentUser()
    return currentUser ? currentUser.getId() : this._throwCreateOrderCheckoutError('Unknown user ID')
  }

  /**
   * @param {String} adId ad identifier
   * @param {Array}  products products to purchase
   * @param {String} testCode force an adyen purchase response
   * @param {String} storeId set default storeId
   * @return {Promise<Object, Error>}
   */
  async execute({adId, products, testCode, storeId, variant, adPrice}) {
    const userId = await this._getUserId()
    const order = await this._repository.createOrder({
      adPrice,
      userId,
      adId,
      products,
      testCode,
      storeId,
      variant
    })

    return order.toJSON()
  }
}
